"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = exports.isValidInput = void 0;
/**
 * Check if the value matches the month reference model
 * A value corresponds to the model if it has two digits followed by a slash and four more digits
 *
 * @param value Input value
 */
exports.isValidInput = function (value) {
    return /\d\d\/\d\d\d\d/.test(value);
};
/**
 * Format a reference month value to pt-br model (month/year)
 *
 * @param value A reference month to be formatted
 */
exports.format = function (value) {
    if (!value || !value.year || value.month == null) {
        return null;
    }
    if (value.month < 9) {
        return "0" + (value.month + 1) + "/" + value.year;
    }
    else {
        return value.month + 1 + "/" + value.year;
    }
};
//# sourceMappingURL=util.js.map